exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mhd--page-footer div .ui.button:not(:last-child) {\n  margin-right: 14px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Structure/footer.scss
// module id = 1306
// module chunks = 1